<template>
  <CModal
    @mtdclosemodal="mtdclosemodal"
    :show.sync="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :fullScreen="true"
  >
    <div class="row">
      <div class="container py-3">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="minimal-card mb-3"
        >
          <!-- HEADER -->
          <div class="minimal-header" @click="toggleCollapse(index)">
            <div class="header-left">
              <div class="patient-avatar">
                {{ index + 1 }}
              </div>

              <div class="header-info">
                <div class="patient-name">
                  {{ item.name }}
                </div>

                <div class="patient-age">
                  Edad:
                  <strong>{{ item.edad }}</strong>
                  años
                </div>
              </div>
            </div>

            <div class="header-right">
              <button
                class="btn-toggle"
                type="button"
                @click.stop="toggleCollapse(index)"
              >
                <i
                  class="fas"
                  :class="item.show ? 'fa-chevron-up' : 'fa-chevron-down'"
                ></i>
              </button>
            </div>
          </div>

          <!-- BODY -->
          <transition name="fade">
            <div class="collapse-container" v-show="item.show">
              <div class="p-3">
                <textarea
                  v-model="item.reporte"
                  rows="5"
                  class="form-control minimal-textarea"
                  placeholder="Digite el reporte médico..."
                ></textarea>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <template #footer>
      <button
        type="button"
        class="btn btn-register text-white"
        @click="mtdCommitReport(1)"
      >
        <i class="fas fa-save"></i>
        Guardar y enviar reporte
      </button>

      <button
        type="button"
        class="btn btn-register text-white"
        @click="mtdCommitReport(0)"
      >
        <i class="fas fa-save"></i>
        Guardar
      </button>

      <button
        type="button"
        class="btn btn-secondary text-white"
        @click="mtdclosemodal"
      >
        <i class="fas fa-times"></i>
        Cerrar
      </button>
    </template>
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import CButtonClose from "@/components/shared/modals/cButtonClose.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

import { mapActions } from "vuex";

export default {
  name: "c-logistica-viewCarritoOC",

  components: {
    CModal,
    CButtonClose,
    SweetAlert,
  },

  props: {
    title: String,
    boo_modal: Boolean,

    report: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      data: [],
    };
  },

  watch: {
    report: {
      immediate: true,

      handler(newVal) {
        this.data = (newVal || []).map((item) => ({
          ...item,
          show: false,
        }));
      },
    },
  },

  computed: {
    cpDisabled() {
      return false;
    },
  },

  methods: {
    ...mapActions(["get", "post"]),

    filterKey(e) {
      let b = false;

      b = /^[0-9]+$/.test(e.key);

      if (!b && e.key != "Backspace") {
        e.preventDefault();
      }
    },

    mtdclosemodal() {
      this.$emit("closeModalReport");
    },

    toggleCollapse(index) {
      this.data[index].show =
        !this.data[index].show;
    },
    mtdCommitReport: function (option) {
      this.$emit("commitReport", this.data,option);
    }
  },
};
</script>

<style scoped>
.minimal-card {
  border: 1px solid #e9ecef;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  transition: all 0.2s ease;
}

.minimal-card:hover {
  border-color: #ced4da;
}

.minimal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;

  background: linear-gradient(
    135deg,
    #f8f9fa 0%,
    #eef1f4 100%
  );

  border-bottom: 1px solid #e9ecef;

  box-shadow: inset 0 -1px 0
    rgba(0, 0, 0, 0.03);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.patient-avatar {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #212529;
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: 600;
}

.header-info {
  display: flex;
  flex-direction: column;
}

.patient-name {
  font-size: 13px;
  font-weight: 600;
  color: #212529;
  line-height: 1.2;
}

.patient-age {
  font-size: 11px;
  color: #6c757d;
}

.header-right {
  display: flex;
  align-items: center;
}

.btn-toggle {
  width: 30px;
  height: 30px;

  border: none;
  border-radius: 8px;

  background: white;

  transition: all 0.2s ease;

  box-shadow: 0 1px 2px
    rgba(0, 0, 0, 0.05);
}

.btn-toggle:hover {
  background: #f1f3f5;
}

.collapse-container {
  background: white;
}

.minimal-textarea {
  border-radius: 10px;
  border: 1px solid #dee2e6;
  resize: none;
  min-height: 120px;
}

.minimal-textarea:focus {
  box-shadow: none;
  border-color: #212529;
}

/* Animación */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>